<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      currentLang: 'zh'
    }
  },
  created() {
    // 从localStorage获取语言设置，如果没有则默认为中文
    const savedLang = localStorage.getItem('lang') || 'zh'
    this.setLanguage(savedLang)
    
    // 初始化翻译设置
    this.$translate.setUseVersion2()
    this.$translate.selectLanguageTag.show = false
    this.$translate.listener.start()
  },
  methods: {
    setLanguage(lang) {
      this.currentLang = lang
      document.documentElement.lang = lang
      localStorage.setItem('lang', lang)
      
      // 设置翻译语言
      if (lang === 'en') {
        this.$translate.changeLanguage('english')
      } else {
        this.$translate.changeLanguage('chinese_simplified')
      }
      this.$translate.execute()
    }
  }
}
</script>

<style>
#app {
  font-family: var(--font-family-zh);
}
</style>



// WEBPACK FOOTER //
// src/App.vue